export default __webpack_public_path__ + "static/media/Reda.d94c85cd.mp4";